export default __webpack_public_path__ + "static/media/olivine13.dc39ad6a.png";